import { axiosInstance } from '../../axios';
import { AdminUser } from '../user';
import { AdminRole } from './role.interface';

export function fetchAdminRoles() {
  return axiosInstance
    .get<AdminRole[]>('/api/admin/role')
    .then((response) => response.data);
}

export function assignAdminUserRole(userId: string, role: AdminRole) {
  return axiosInstance
    .post<AdminUser>(`/api/admin/role/${userId}`, { role })
    .then((response) => response.data);
}
